import styles from './LanguageCircle.module.css'

export default function LanguageCircle({color}: {color: string | undefined}) {
  return (
    <div className={styles.languageCircle} style={{backgroundColor: color || 'var(--bgColor-attention-emphasis)'}} />
  )
}
